import React, { CSSProperties, PropsWithChildren } from 'react';

import ErrorNetwork from 'components/error-network';
import { CookieBannerContainer } from 'components/layout/cookie-banner-container';
import useLogPageView from 'components/layout/use-log-page-view';
import { useResetStoreResetCartResetServiceModeTimeout } from 'hooks/reset-store-timeout';
import { useDatadogRum } from 'hooks/rum/use-datadog-rum';
import { useForter } from 'hooks/use-forter';
import useGoogleAnalytics from 'hooks/use-google-analytics';

const skipLinkBaseStyle: CSSProperties = {
  position: 'absolute',
  left: '-9999px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  zIndex: 9999,
};

const skipLinkFocusStyle: CSSProperties = {
  position: 'fixed',
  left: '16px',
  top: '16px',
  width: 'auto',
  height: 'auto',
  overflow: 'visible',
  backgroundColor: '#ffffff',
  color: '#000000',
  padding: '8px 16px',
  fontWeight: 'bold',
  textDecoration: 'none',
  border: '2px solid #000000',
  borderRadius: '4px',
  zIndex: 9999,
};

/**
 * Once the React Navigate is fully tested and in PROD, we can deprecate the ENABLE_REACT_NATIVE_NAVIGATION feature flag.
 * At which point this file will have its web counterpart instead of app-container-rn and app-container-web.
 */
export const AppContainer = ({ children: AppContainerComponent }: PropsWithChildren) => {
  useGoogleAnalytics();
  useResetStoreResetCartResetServiceModeTimeout();
  useDatadogRum();
  useForter();
  useLogPageView();

  return (
    <>
      <a
        href="#main-content"
        style={skipLinkBaseStyle}
        onFocus={e => Object.assign((e.target as HTMLAnchorElement).style, skipLinkFocusStyle)}
        onBlur={e => Object.assign((e.target as HTMLAnchorElement).style, skipLinkBaseStyle)}
      >
        Skip to main content
      </a>
      <CookieBannerContainer />
      {AppContainerComponent}
      <ErrorNetwork />
    </>
  );
};
